// Browser page translators (Google Translate, Edge…) replace text nodes with <font> wrappers,
// which makes React crash on removeChild/insertBefore. Make those calls tolerant instead of fatal.
if (typeof Node === 'function' && Node.prototype) {
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      console.warn('[domGuard] removeChild ignored: node already moved (page translation?)');
      return child;
    }
    return removeChild.apply(this, arguments);
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('[domGuard] insertBefore ignored: reference node moved (page translation?)');
      return newNode;
    }
    return insertBefore.apply(this, arguments);
  };
}
